import autobind from 'core-decorators/lib/autobind';
import { SocialShare } from 'widget/player-widget';
import { connect } from 'react-redux';

import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';
import { isChannelShareVisible } from 'shared/utils/layout-helpers';

import { getAllSettings } from 'shared/selectors/app-settings';

import reportStats from 'widget/redux/server/actions/stats/report';

import STATS_EVENTS from 'shared/constants/stats/events';

import { openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';
import Icon from 'shared/components/icon/icon';

import styles from './share-channel.styl';


export function getContentToShare(channelData, appSettings) {
  if (!channelData) {
    return {};
  }

  const { siteUrl } = appSettings;
  const { title, description } = channelData;
  const coverUrl = channelData.customCoverUrl || channelData.coverUrl;

  return {
    siteUrl,
    title,
    description,
    coverUrl,
  };
}


@connect(state => ({
  appSettings: getAllSettings(state),
}), {
  reportStats,
})
@VODBiEvents()
@VODCSSModules(styles)
export default class ShareChannel extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
    buttonsClassName: React.PropTypes.string,
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    reportStats: React.PropTypes.func,
    biEvent: React.PropTypes.func,
  };

  get networksClassNames() {
    return _.pick(styles, 'facebook', 'twitter', 'pinterest', 'tumblr');
  }

  sendSharedBI(networkName) {
    this.props.biEvent('widget.share.clicked', { typeShare: networkName });
  }

  sendStatsReport(name) {
    const { reportStats, channelData: channel } = this.props;

    reportStats(STATS_EVENTS.CHANNEL_SHARE, {
      network: {
        name,
      },
      channel,
    });
  }

  @autobind
  handleAfterClicked(networkName) {
    this.sendSharedBI(networkName);
    this.sendStatsReport(networkName);
  }

  render() {
    const { appSettings, className, buttonsClassName, channelData } = this.props;

    if (!isChannelShareVisible(appSettings)) {
      return null;
    }

    const contentToShare = getContentToShare(channelData, appSettings);
    return (
      <section styleName="share-container"
               className={`qa-share-channel ${className}`}>
        <SocialShare styleName="share-buttons"
                     className={buttonsClassName}
                     buttonClassName={styles['share-button']}
                     networksClassNames={this.networksClassNames}
                     onAfterClicked={this.handleAfterClicked}
                     networks={['facebook', 'twitter', 'pinterest', 'tumblr']}
                     content={contentToShare}
                     appSettings={appSettings}
                     openPreviewPrompt={openPreviewPrompt} />
        <Icon name="share"
              styleName="share" />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/share-channel/share-channel.js